import { InputHTMLAttributes, forwardRef } from 'react';

import { cn } from '../utils/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  errorMessage?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, errorMessage, ...props }, ref) => {
    return (
      <div className="w-full">
        <input
          ref={ref}
          className={cn(
            'w-full px-3 py-2 rounded-[var(--ids-radius-md,10px)] border transition-colors',
            'bg-[color:var(--ids-bg-subtle,#0F1626)] text-[color:var(--ids-text,#F8FAFC)] placeholder:text-[color:var(--ids-text-subtle,#7E8DA6)]',
            'focus:outline-none focus:ring-2 focus:ring-offset-0 focus:bg-[color:var(--ids-surface,#141B2D)]',
            'disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-[color:var(--ids-bg-subtle,#0F1626)]',
            {
              'border-[color:var(--ids-border,rgba(255,255,255,0.08))] focus:border-[color:var(--ids-brand,#3B82F6)] focus:ring-[color:rgba(var(--ids-brand-rgb,59,130,246),0.18)]':
                !error,
              'border-[color:var(--ids-danger,#EF4444)] focus:border-[color:var(--ids-danger,#EF4444)] focus:ring-[color:rgba(var(--ids-danger-rgb,239,68,68),0.16)]':
                error,
            },
            className
          )}
          {...props}
        />
        {error && errorMessage && (
          <p className="mt-1 text-sm text-[color:var(--ids-danger,#EF4444)]">{errorMessage}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
